import { Injectable, computed, inject, resource } from "@angular/core";
import { AuthService, type CurrentUser } from "@shared/index";

type AccordionState = Record<string, boolean>;

type GetAccordionStateFunction = (accordionId: string) => boolean;

@Injectable({ providedIn: "root" })
export class AccordionsService {
    private readonly authService = inject(AuthService);

    private accordionStates = resource<AccordionState, CurrentUser | null>({
        defaultValue: {},
        params: () => this.authService.currentUser(),
        loader: ({ params: currentUser }: { params: CurrentUser | null }) => {
            if (!currentUser) return {};
            const savedStates = localStorage.getItem(`accordionStates_${currentUser.sub}`);
            return savedStates ? JSON.parse(savedStates) : {};
        },
    });

    public getAccordionState = computed<GetAccordionStateFunction>(() => {
        const savedStates = this.accordionStates.value();
        return (accordionId: string) => savedStates[accordionId] ?? null;
    });

    public setAccordionState(accordionId: string, isOpen: boolean): void {
        const currentUser = this.authService.currentUser();
        if (!currentUser) return;
        const updatedStates = { ...this.accordionStates.value(), [accordionId]: isOpen };
        this.accordionStates.set(updatedStates);
        localStorage.setItem(`accordionStates_${currentUser.sub}`, JSON.stringify(updatedStates));
    }
}
